export const amountToDollars = (amount) => {
  return (amount / 100) || 0.00;
};